var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M8.66 2a.5.5 0 0 1 .354.146l3.06 3.06 5.277 5.268c.742.738.746 1.82.01 2.554l-5.25 5.25a.5.5 0 0 1-.707 0L2.748 9.626A2.557 2.557 0 0 1 2 7.818V2.5a.5.5 0 0 1 .5-.5Zm-.208 1H3v4.818c0 .361.125.71.352.986l.103.115 8.302 8.297 4.898-4.897c.342-.341.34-.788-.01-1.137L8.453 3ZM4.75 4.201a1.5 1.5 0 1 1 1.5 2.598 1.5 1.5 0 0 1-1.5-2.598Zm1 .866a.5.5 0 0 0-.5 0l-.072.05a.5.5 0 1 0 .572-.05Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export default ForwardRef;